export const excludeAlive = [
    'UserConsoleHome',
    'ProjKpiPage',
    'UserProjKpiPage',
    'ProjKpiTable',
    'ProjKpiMonitorList',
    'ProjKpiMonitor',
    'ProjAppraiseScoring',
    'ProjAppraiseWeightSetting',
    'ImportProjKpiWizard',
    'ImportProjectWizard',
];
